import "../../../../src/content/naples-festival/napoli.scss";
import * as React from 'react';
export default {
  React
};